// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1l-Ol","check":"style_check__3S97r","noBorderBottom":"style_noBorderBottom__1Kkq8"};